/**
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import { FormatLocaleDefinition } from 'd3-format';

export const DEFAULT_D3_FORMAT: FormatLocaleDefinition = (() => {
  /**
   * Change made here to make locale switching for number format easier
   * Will get changed to other means if there's any way to expose SS current locale
   * 2025-06-11 DKohout@DCUK
   */
  const defaultLocale = (() => {
    const appContainer = document.getElementById('app');
    const dataBootstrap = appContainer?.getAttribute('data-bootstrap');
    return dataBootstrap ? JSON.parse(dataBootstrap).common.locale : 'en';
  })();

  if (defaultLocale === 'cs') {
    return {
      decimal: ',',
      thousands: '\u00a0',
      grouping: [3],
      currency: ['', '\u00a0Kč'],
      prefixes: [
        '\u00a0yokto',
        '\u00a0zepto',
        '\u00a0atto',
        '\u00a0femto',
        '\u00a0piko',
        '\u00a0nano',
        '\u00a0mikro',
        '\u00a0mili',
        '',
        '\u00a0tis.',
        '\u00a0mil.',
        '\u00a0mld.',
        '\u00a0bil.',
        '\u00a0bld.',
        '\u00a0tril.',
        '\u00a0trd.',
        '\u00a0kvad.',
      ],
    };
  }
  return {
    decimal: '.',
    thousands: ',',
    grouping: [3],
    currency: ['$', ''],
  };
})();
